var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tilled-card-edit"},[_c('tilled-new-card',{attrs:{"id":_vm.id},on:{"confirm":_vm.confirm,"cancel":_vm.cancel}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }